import { Component } from "react";
import { formatDate } from "../../common/services/utilities";
import ThemeableAgGrid from "../../common/components/agGrid/ThemeableAgGrid";
import { withTranslation } from "react-i18next";

class AlbertaEnvironmentalStatusChangesTable extends Component {
  // Define column definitions using the getColumnDefs method
  getColumnDefs() {
    return [
      //{field: 'TransactionId', headerName: this.props.t("TransactionId")},
      {
        field: "TransactionDate",
        headerName: this.props.t("TransactionDate"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Owner",
        headerName: this.props.t("Owner"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Quantity",
        headerName: this.props.t("Quantity"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Registry",
        headerName: this.props.t("Registry"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Vintage",
        headerName: this.props.t("Vintage"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "QuantificationProtocol",
        headerName: this.props.t("QuantificationProtocol"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "OldEmissionOffsetStatus",
        headerName: this.props.t("OldEmissionOffsetStatus"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "NewEmissionOffsetStatus",
        headerName: this.props.t("NewEmissionOffsetStatus"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "SerialStart",
        headerName: this.props.t("SerialStart"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "SerialEnd",
        headerName: this.props.t("SerialEnd"),
        filter: false,
        floatingFilter: false,
      },
    ];
  }

  mapToViewModel(statusChanges) {
    return statusChanges.map((statusChange, index) => ({
      index: index,
      Id: statusChange.Id,
      TransactionId: statusChange.TransactionId,
      TransactionDate: formatDate(statusChange.TransactionDate),
      Owner: statusChange.Owner,
      Seller: statusChange.Seller,
      Quantity: statusChange.Quantity,
      Registry: statusChange.Registry,
      Vintage: statusChange.Vintage,
      QuantificationProtocol: statusChange.QuantificationProtocol,
      OldEmissionOffsetStatus: statusChange.OldEmissionOffsetStatus,
      NewEmissionOffsetStatus: statusChange.NewEmissionOffsetStatus,
      SerialStart: statusChange.SerialStart,
      SerialEnd: statusChange.SerialEnd,
    }));
  }

  render() {
    const { statusChanges, onRowClick } = this.props;

    const mappedStatusChanges = this.mapToViewModel(statusChanges);
    const columnDefs = this.getColumnDefs();

    // Pagination configuration
    const paginationConfig = {
      // Enable pagination for all tables regardless of size
      enabled: true,
      // Default page size
      pageSize: 20,
      // Available page size options for user to choose
      pageSizeOptions: [5, 10, 20, 50, 100],
    };

    return (
      <ThemeableAgGrid
        className="table-extra-small"
        columnDefs={columnDefs}
        rowData={mappedStatusChanges}
        onRowClicked={(params) => onRowClick && onRowClick(params.data)}
        getRowId={(params) => String(params.data.index)}
        pagination={true}
        paginationPageSize={paginationConfig.pageSize}
        paginationPageSizeSelector={paginationConfig.pageSizeOptions}
        suppressPaginationPanel={false}
        allowHorizontalScroll={false}
      />
    );
  }
}

export default withTranslation(["marketdata"])(
  AlbertaEnvironmentalStatusChangesTable
);
